<template>
    <button
        type="button"
        class="ui-control-select-all"
        :class="{ 'ui-control-select-all--active': allSelected }"
        :disabled="disabled"
        @click="$emit('toggle')"
    >
        {{ allSelected ? 'Убрать все' : 'Выбрать все' }}
    </button>
</template>

<script setup>
defineProps({
    allSelected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
});

defineEmits(['toggle']);
</script>
